import { Grid, makeStyles, Typography } from '@material-ui/core';
import { COLORS } from '../../../plTheme';
import WidgetCard from '../../atoms/WidgetCard';
import { getDashboardData_getDashboardData_salesOutcome_productPenetration as DashboardProductPenetration } from '../../../gql/types';
import React from 'react';
import { _t_ } from '../../../utils/translation/translation';
import { useWindowSize } from '../../../utils/hooks/useWindowSize';
import { useGlobalStyles } from '../../../plStyles';

interface ProductPenetrationProps {
  penetrationData?: (DashboardProductPenetration | null)[] | null | undefined;
  activeQuarter: number | null | undefined;
  totalDeals: number | null | undefined;
  reportInd: boolean;
  isProd: boolean;
}

const ProductPenetrationWidget: React.FC<ProductPenetrationProps> = ({
  penetrationData,
  activeQuarter,
  totalDeals,
  reportInd,
  isProd,
}: ProductPenetrationProps) => {
  const [width] = useWindowSize();

  const useStyles = makeStyles({
    root: {},
    textTransformation: {
      display: 'inline-block',
      // maxWidth: '110%',
      height: 'auto',
      whiteSpace: 'nowrap',
      // overflow: 'hidden',
      // textOverflow: 'ellipsis',
      textTransform: 'uppercase',
    },
    textcolor: {
      color: COLORS.PL_PRIMARY,
      fontSize: 18,
      paddingRight: 8,
      minWidth: 58,
      display: 'inline-block',
      textAlign: 'right',
    },
    productColor: {
      marginLeft: 20,
      color: COLORS.TEXT_HIGH_EMPHASIS,
    },
    dealsColor: {
      color: COLORS.TEXT_LOW_EMPHASIS,
      paddingRight: '1%',
    },
    textPadding: {
      paddingLeft: 8,
      paddingRight: 2,
    },
    heading: {
      textTransform: 'uppercase',
      color: COLORS.GREY_100,
    },
    griditem: {
      padding: 16,
      display: 'flex',
    },
    griditem1: {
      paddingLeft: 18,
      paddingBottom: reportInd ? 8 : 18,
      display: 'flex',
      alignItems: 'baseline',
    },
    griditem2: {
      paddingLeft: 18,
      paddingBottom: 8,
      display: 'flex',
      alignItems: 'baseline',
    },
    textInfo: {
      marginBottom: '2%',
      height: '134px',
      overflowX: 'hidden',
      '&::-webkit-scrollbar': {
        width: 6,
        borderRadius: 10,
        marginRight: '10px',
      },
      '&::-webkit-scrollbar-track': {
        borderRadius: '10px',
        // marginTop: '10px',
      },
      '&::-webkit-scrollbar-thumb': {
        minHeight: 40,
        backgroundColor: '#CFD6DE',
        borderRadius: '10px',
      },
    },
  });

  const classes = useStyles();

  const dealsFraction = (
    productPenetration: DashboardProductPenetration | null,
    totalDeals: number,
  ) => {
    const dealcount = productPenetration && productPenetration?.dealCount;
    return (((dealcount || 0) / totalDeals) * 100).toFixed(1);
  };

  const globalClasses = useGlobalStyles();

  const prodName = [
    'Business Insurance',
    'Merchant Services',
    'Investment solutions',
    'Investment solutionss',
  ];

  const data = isProd
    ? [
        {
          __typename: 'ProductPenetration',
          product: {
            __typename: 'Product',
            id: '5bfd72c5-282b-4c2d-8181-d215f893382c',
            name: 'of customers w/ Lending',
          },
          dealCount: 60,
        },
        {
          __typename: 'ProductPenetration',
          product: {
            __typename: 'Product',
            id: '9928ec01-185a-4d84-9a6a-2f741b8e95ce',
            name: 'of customer w/ Lending & Treasury',
          },
          dealCount: 20,
        },
        {
          __typename: 'ProductPenetration',
          product: {
            __typename: 'Product',
            id: '1b41f9a8-f7d7-4e4d-885f-886a789b3ad3',
            name: 'of customer w/ Lending & Treasury & Payments',
          },
          dealCount: 20,
        },
      ]
    : [
        {
          __typename: 'ProductPenetration',
          product: {
            __typename: 'Product',
            id: '5bfd72c5-282b-4c2d-8181-d215f893382c',
            name: 'Business Insurance',
          },
          dealCount: 20456,
        },
        {
          __typename: 'ProductPenetration',
          product: {
            __typename: 'Product',
            id: '9928ec01-185a-4d84-9a6a-2f741b8e95ce',
            name: 'Merchant Services',
          },
          dealCount: 1574,
        },
        {
          __typename: 'ProductPenetration',
          product: {
            __typename: 'Product',
            id: '1b41f9a8-f7d7-4e4d-885f-886a789b3ad3',
            name: 'Investment solutions',
          },
          dealCount: 690,
        },
      ];

  const amount = isProd
    ? ['60%', '20%', '20%', ]
    : ['$162M', '$135M', '$126M', '$1.0 M'];

  return (
    <WidgetCard>
      <Grid
        container
        direction="column"
        className={classes.root}
        style={{ height: '100%' }}
      >
        <Grid item container className={classes.griditem} alignItems="baseline">
          <Typography className={globalClasses.body1WidgetTitle}>
            {_t_(isProd ? 'Products Per Customer' : 'Cross Selling Revenue ')}
          </Typography>
        </Grid>
        <Grid item className={classes.textInfo}>
          {data &&
            data?.map((element: any, key: number) => {
              return (
                element && (
                  <Grid
                    item
                    className={
                      data.length === key - 1
                        ? classes.griditem2
                        : classes.griditem1
                    }
                    key={key}
                  >
                    <Typography
                      variant="subtitle1"
                      color="textSecondary"
                      className={classes.textTransformation}
                    >
                      <span
                        style={{ width: '5%' }}
                        className={classes.textcolor}
                        data-testid="productPenetrationWidgetPercentage"
                      >
                        {/* {totalDeals && dealsFraction(element, totalDeals)}% */}
                        {amount[key]}
                      </span>

                      {/* <span
                          className={classes.dealsColor}
                          data-testid="productPenetrationWidgetPercentage"
                        >
                          {reportInd
                            ? _t_(' Deals w/ ')
                            : _t_(' OF DEALS CONTAIN ')}
                        </span> */}
                      <span className={classes.productColor}>
                        {/* {prodName[key]} */}
                        {element?.product?.name
                          ? element?.product?.name
                          : `Product ${key}`}
                      </span>
                    </Typography>
                  </Grid>
                )
              );
            })}
          {!penetrationData && (
            <Typography variant="subtitle1" color="textSecondary">
              {_t_('No Deals Closed')}
            </Typography>
          )}
        </Grid>
      </Grid>
    </WidgetCard>
  );
};

export default ProductPenetrationWidget;
